import React from 'react';
import { Contact, Footer } from '../components'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Meta from '../components/common/Meta';


export const ContactPage = () => {
  return (
    <div>
      <Meta
        title="Contact Us | Architecture & Engineering Consultants Rwanda"
        description="Contact Edges Design Group for architectural design, engineering consulting, construction management, surveying, and project advisory services in Rwanda."
        keywords="
          Construction consultant Rwanda,
          Building project advisor Kigali,
          Construction technical support,
          Quantity surveying Rwanda,
          Construction cost management Kigali,
          Project budgeting and estimation,
          Land surveying Rwanda,
          Site analysis Kigali,
          Topographic survey services,
          Building project advisor Kigali
          "
      />

      <ToastContainer />
      <nav className=' bg-contact-page justify-center pt-10 min-h-[250px] bg-cover' >
        <h1 className='font-bold text-5xl text-white uppercase text-center'>Contact us</h1>
        <p className='text-xl text-center text-gray-400 mt-4'>We would love to hear from you</p>
      </nav>

      <Contact />
      <div className=' w-full h-1 bg-gray-400'></div>
      <Footer />
    </div>
  )
}

export default ContactPage
